import {ListItemButton, ListItemText} from '@mui/material';
import React from 'react';

/**
 * @param {string} title - title of the option
 * @param {string} [description] - description of the option
 * @param {function} onClick - callback fired when the option is clicked
 */
const Option = ({title, description, onClick, ...props}) => {
  return (
    <ListItemButton divider onClick={onClick} {...props}>
      <ListItemText
        primary={title}
        secondary={description}
        slotProps={{
          primary: {
            noWrap: true,
          },
        }}
      />
    </ListItemButton>
  );
};

export default Option;
